interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

export default function UserEditIcon({ width = '20', height = '20', className = '' }: IconProps) {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.99967 10.0013C12.3009 10.0013 14.1663 8.13582 14.1663 5.83464C14.1663 3.53345 12.3009 1.66797 9.99967 1.66797C7.69849 1.66797 5.83301 3.53345 5.83301 5.83464C5.83301 8.13582 7.69849 10.0013 9.99967 10.0013Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.0085 13.1181L13.0585 16.0682C12.9418 16.1848 12.8335 16.4015 12.8085 16.5598L12.6502 17.6848C12.5919 18.0931 12.8752 18.3765 13.2835 18.3181L14.4085 18.1598C14.5668 18.1348 14.7919 18.0265 14.9002 17.9098L17.8502 14.9598C18.3585 14.4515 18.6002 13.8598 17.8502 13.1098C17.1085 12.3681 16.5169 12.6098 16.0085 13.1181Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.584 13.543C15.834 14.443 16.534 15.1429 17.434 15.3929"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.8418 18.3333C2.8418 15.1083 6.05015 12.5 10.0002 12.5C10.8668 12.5 11.7001 12.625 12.4751 12.8583"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
}
